import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { SIMERA_CLIENT_ROUTE } from '$constants/routes';
import classes from './SimeraCompanyScreen.module.css';
import Spinner from '../../Spinner/Spinner';
import EmployeesTable from './EmployeesTable/EmployeesTable';
import CandidatesBackButton from '../../CandidateDetails/BackButton/CandidatesBackButton';
import {
  useGetClientsByCompanyIdQuery,
  useGetEmployeesByCompanyQuery,
} from '../../../store/modules/companies';
import ClientsTable from './ClieentsTable/ClientsTable';

const SimeraCompanyScreen = () => {
  const { id } = useParams();
  const [t] = useTranslation('global');
  const navigate = useNavigate();
  const {
    data = [],
    isLoading,
    isFetching,
  } = useGetEmployeesByCompanyQuery({
    companyId: Number(id!),
  });

  const {
    data: clientData = [],
    isLoading: isLoadingClients,
    isFetching: isFetchingClients,
  } = useGetClientsByCompanyIdQuery({
    companyId: Number(id!),
  });

  const employees = useMemo(
    () =>
      data?.map((employee) => ({
        candidateId: employee.Candidate.Id,
        name: `${employee.Candidate.User.FirstName} ${employee.Candidate.User.LastName}`,
        positionName: employee.Position.JobPosition.title,
        startDate: employee.StartDate
          ? dayjs(employee.StartDate).format('MM/DD/YYYY')
          : 'N/A',
        salary: employee.Salary ? employee.Salary : 'N/A',
        endDate: employee.EndDate
          ? dayjs(employee.EndDate).format('MM/DD/YYYY')
          : 'N/A',
        candidatePositionStatusId: employee.Id,
      })),
    [data]
  );

  const clients = useMemo(
    () =>
      clientData?.map((singleClient) => {
        return {
          name: `${singleClient.User.FirstName} ${singleClient.User.LastName}`,
          email: singleClient.User.Email,
          startDate: dayjs(singleClient.CreateTime).format('MM/DD/YYYY'),
          agreedTermsOfServiceDate: singleClient.AgreedTermsOfServiceDate
            ? dayjs(singleClient.AgreedTermsOfServiceDate).format('MM/DD/YYYY')
            : 'N/A',
        };
      }) || [],
    [clientData]
  );
  return (
    <div className={classes.container}>
      <div>
        <CandidatesBackButton
          text={t('CompaniesTable.Back')}
          onClick={() => {
            navigate(SIMERA_CLIENT_ROUTE, { replace: true });
          }}
          isSecondary
        />
      </div>
      <div className={`${classes.content} flex flex-col`}>
        <div>
          <div className="w-full flex flex-row items-center mb-4">
            <div className="w-full h-1 border-b border-solid border-neutral-400" />
            <h1 className="font-semibold text-2xl text-nowrap mx-4">
              {t('CompaniesTable.WorkersHistory')}
            </h1>
            <div className="w-full h-1 border-b border-solid border-neutral-400" />
          </div>
          <div data-testid="employees-table">
            {isLoading || isFetching ? (
              <div className={classes.spinnerContainer}>
                <Spinner secondary height="100%" width="100%" />
              </div>
            ) : (
              <EmployeesTable data={employees} rawData={data} />
            )}
          </div>
        </div>
        <div className="mt-4">
          <div className="w-full flex flex-row items-center mb-4">
            <div className="w-full h-1 border-b border-solid border-neutral-400" />
            <h1 className="font-semibold text-2xl text-nowrap mx-4">
              {t('CompaniesTable.ClientsUsers')}
            </h1>
            <div className="w-full h-1 border-b border-solid border-neutral-400" />
          </div>
          {isLoadingClients || isFetchingClients ? (
            <div className={classes.spinnerContainer}>
              <Spinner secondary height="100%" width="100%" />
            </div>
          ) : (
            <ClientsTable data={clients} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SimeraCompanyScreen;
